import { workflowComponent } from '@banking/ui/services/bank-accounts';
import { Screen, userClickUpdateBankAccountAction, toggleChangeBankAccountModalAction } from '@banking/ui/workflows/bank-accounts/change-bank-account';
import { hbs } from 'ember-cli-htmlbars';
const template = hbs`
  <Banking::BankAccounts::Modal
    @active={{this.showChangeBankAccountModal}}
    @closeModal={{this.onUserClickCloseModal}}
  >
    {{#if this.showConfirmScreen}}
      <Banking::BankAccounts::ChangeBankAccount::Confirm
        @userClickUpdateBankAccount={{this.userClickUpdateBankAccount}}
        @onUserClickCloseModal={{this.onUserClickCloseModal}}
        @selectedBankLabel={{this.selectedBankLabel.bankAccountLabel}}
        @selectedLocationName={{this.selectedLocationName}}
      />
    {{else if this.showLoadingScreen}}
      <Banking::BankAccounts::ChangeBankAccount::Loading
        @selectedBankLabel={{this.selectedBankLabel.bankAccountLabel}}
        @selectedLocationName={{this.selectedLocationName}}
        @onDoneClick={{this.onUserClickCloseModal}}
      />
    {{else if this.showSuccessScreen}}
      <Banking::BankAccounts::SuccessfulBankLink
        @bankLabel={{this.selectedBankLabel.bankAccountLabel}}
        @locationName={{this.selectedLocationName}}
        @onDoneClick={{this.onUserClickCloseModal}}
      />
    {{else if this.showErrorScreen}}
      <Banking::BankAccounts::FailedBankLink
        @locationName={{this.selectedLocationName}}
        @onDoneClick={{this.onUserClickCloseModal}}
      />
    {{/if}}
  </Banking::BankAccounts::Modal>
`;
const mapStateToProps = state => ({
  selectedBankLabel: state.changeBankAccountModal.selectedBankLabel || null,
  selectedLocationName: state.changeBankAccountModal.selectedLocationName || null,
  showChangeBankAccountModal: state.changeBankAccountModal.isModalOpen,
  showConfirmScreen: state.changeBankAccountModal.screen === Screen.CONFIRM,
  showErrorScreen: state.changeBankAccountModal.screen === Screen.ERROR,
  showLoadingScreen: state.changeBankAccountModal.screen === Screen.LOADING,
  showSuccessScreen: state.changeBankAccountModal.screen === Screen.SUCCESS
});
const mapActionsToProps = () => ({
  onUserClickCloseModal: toggleChangeBankAccountModalAction,
  userClickUpdateBankAccount: userClickUpdateBankAccountAction
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);